import { render, staticRenderFns } from "./SetFamilyHubUserPassword.vue?vue&type=template&id=25af58b4&scoped=true"
import script from "./SetFamilyHubUserPassword.vue?vue&type=script&lang=js"
export * from "./SetFamilyHubUserPassword.vue?vue&type=script&lang=js"
import style0 from "./SetFamilyHubUserPassword.vue?vue&type=style&index=0&id=25af58b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25af58b4",
  null
  
)

export default component.exports